import * as React from 'react';
import { default as BaseButton } from '../../../../BaseComponents/Button';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import cn from 'classnames';

interface Props {
	segmentId: number;
	segmentsCount: number;
	onProceed?: () => void;
	onSelectNextFlight?: () => void;
	onClear?: () => void;
	clearEnable?: boolean;
	onBack?: () => void;
}

const Controls: React.FC<Props> = props => {
	const { t } = useTranslation('SeatMap');

	const theme = useTheme('SeatMap').Controls;

	return (
		<div className={theme.controls}>
			{props.segmentId > 0 && props.onBack && (
				<BaseButton variant="smallSecondary" className={cn(theme.button, theme.back)} onClick={props.onBack}>
					{t('Back')}
				</BaseButton>
			)}

			{props.segmentId + 1 !== props.segmentsCount ? (
				<BaseButton
					variant="smallPrimary"
					className={theme.button}
					onClick={props.onSelectNextFlight}
					data-next-button={true}
					data-test-id="seat-map-continue"
				>
					{t('Next flight')}
				</BaseButton>
			) : (
				<BaseButton
					variant="smallPrimary"
					className={theme.button}
					onClick={props.onProceed}
					data-next-button={true}
					data-test-id="seat-map-continue"
				>
					{t('Continue')}
				</BaseButton>
			)}
		</div>
	);
};

export default Controls;
